import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";

import { UniversalSearchBarComponent, ActiveFiltersComponent } from "./";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatSelectModule } from "@angular/material/select";
import { MatInputModule } from "@angular/material/input";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { TranslateModule } from "@ngx-translate/core";
import { MatIconModule } from "@angular/material/icon";
import { MatChipsModule } from "@angular/material/chips";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatMenuModule } from "@angular/material/menu";

@NgModule({
    declarations: [UniversalSearchBarComponent, ActiveFiltersComponent],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatSelectModule,
        MatInputModule,
        MatAutocompleteModule,
        TranslateModule,
        MatIconModule,
        MatChipsModule,
        MatTooltipModule,
        MatMenuModule,
    ],
    exports: [UniversalSearchBarComponent, ActiveFiltersComponent],
})
export class UniversalSearchBarModule { }
